import { render, staticRenderFns } from "./MoveToArchive.vue?vue&type=template&id=786957fb&scoped=true"
import script from "./MoveToArchive.vue?vue&type=script&lang=js"
export * from "./MoveToArchive.vue?vue&type=script&lang=js"
import style0 from "./MoveToArchive.vue?vue&type=style&index=0&id=786957fb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786957fb",
  null
  
)

export default component.exports